import { merge } from 'lodash'
import { SET_EVENT_SCHEDULE_SUCCESS } from '../actions/setEventSchedule'

const initialState = {
  data: null,
}

export default function eventScheduleData(state = initialState, action) {
  switch (action.type) {
    case SET_EVENT_SCHEDULE_SUCCESS:
      return {
        ...state,
        data: merge({}, state.data, action.payload),
      }
    default:
      return state
  }
}
